import type { Distance, Point, SpatialRectangle } from "@pdfking/math"
import { AddMargins } from "@pdfking/math"

import type { GrowLeaf } from "#internal"

/** The piece's box with its bleed in: the boxes so tile the grow. */
export const GrowLeafPadded = ({ box, padding }: GrowLeaf): SpatialRectangle<Distance> =>
  AddMargins(box, padding)

/** The box's corners, round from its lower left, counter-clockwise. */
export const BoxCorners = ({
  x,
  y,
  width,
  height,
}: SpatialRectangle<Distance>): Point<Distance>[] => [
  { x, y },
  { x: (x + width) as Distance, y },
  { x: (x + width) as Distance, y: (y + height) as Distance },
  { x, y: (y + height) as Distance },
]

/** Whether the piece's corners are its box's: no taper draws its tip in. */
export const GrowLeafBoxed = (leaf: GrowLeaf): boolean =>
  BoxCorners(leaf.box).every((c, i) => c.x === leaf.corners[i]!.x && c.y === leaf.corners[i]!.y)
